import React, { useEffect, useState } from "react";
import {
  Avatar,
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableColumn,
  TableHeader,
  TableRow,
} from "@nextui-org/react";
import {
  getFilterDataWithPagination,
  StringLimit,
} from "../../controllers/APIController";
import { DateFormatorDD } from "../../utils/helper";
import { Colors, numColors } from "../../utils/constant";
import { useNavigate, useParams } from "react-router-dom";
import BreadCrumbsPage from "../../components/BreadCrumbsPage";
import LoadingPage from "../../components/Loader/LoadingPage";
import TableSkeleton from "../../components/Skeleten/TableSkeleton";

const Logs = () => {
  const { _orgId: currOrg } = useParams();
  const [responseData, setResponseData] = useState([]);
  const [Loader, setLoader] = useState(true);
  const [categroyName, setCategoryName] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const ItemPerPage = 20;

  const navigate = useNavigate();
  const UserLogged = JSON.parse(sessionStorage.getItem("userData"));
  const OrgInfo = UserLogged && UserLogged.user.LastOrgId;
  const orgFilterUrl = "filters[Organization][id][$eqi]=" + OrgInfo;

  const navigateHandler = (metric, id) => {
    const category = categroyName[metric]?.toLowerCase().replaceAll(" ", "-");
    const Navigator = metric?.toLowerCase().replaceAll(" ", "-");
    if (category === "reference-data" || category === "framework") {
      navigate(`/${currOrg}/${category}/${Navigator}/${id}`);
    } else navigate(`/${currOrg}/metrics/${category}/${Navigator}/${id}`);
  };

  useEffect(() => {
    getFilterDataWithPagination(
      "responses",
      `${orgFilterUrl}&sort[0]=updatedAt:desc`,
      currentPage,
      ItemPerPage
    )
      .then((data) => {
        setResponseData(data?.data);
        if (totalPage !== 0) setTotalPage(data?.meta?.pagination?.pageCount);
        setLoader(false);
      })
      .catch((err) => {
        // Handle error silently
      });
  }, [currentPage, totalPage, orgFilterUrl]);

  useEffect(() => {
    const categoryList = {};
    const result = responseData.map(async (item) => {
      const url =
        orgFilterUrl + "&filters[Name][$eqi]=" + item?.attributes?.Metric_Id;
      const response = await getFilterDataWithPagination("metrics", url, 1, 1);
      categoryList[item?.attributes?.Metric_Id] =
        response?.data[0]?.attributes?.Category || "Unknown";
      return response;
    });

    Promise.all(result).then(() => {
      setCategoryName(categoryList);
    });
  }, [responseData, orgFilterUrl]);

  return (
    <div className="min-h-screen bg-neutral-50">
      {/* Header */}
      <div className="bg-white border-b border-neutral-200 px-8 py-6 shadow-sm">
        <div className="max-w-full">
          <h1 className="text-2xl font-semibold text-neutral-900">Activity Logs</h1>
          <p className="text-sm text-neutral-600 mt-1">Track all ESG metric updates and changes</p>
        </div>
      </div>

      <BreadCrumbsPage>
        <div className="max-w-7xl mx-auto px-8 py-8">
          {/* Overview Card */}
          <div className="bg-white rounded-lg border border-neutral-200 shadow-sm p-6 mb-8">
            <h2 className="text-lg font-semibold text-neutral-900 mb-3">ESG Metric Logs</h2>
            <p className="text-neutral-600 leading-relaxed">
              View the comprehensive logs of all your ESG (Environmental, Social,
              and Governance) metric responses here. Track and analyze your
              organization's sustainability and ethical performance in detail,
              ensuring transparency and accountability in your ESG reporting
              process.
            </p>
          </div>

          {/* Logs Table */}
          <LoadingPage isLoading={Loader} alterElement={<TableSkeleton />}>
            <div className="bg-white rounded-lg border border-neutral-200 shadow-sm overflow-hidden">
              <div className="px-6 py-4 border-b border-neutral-200">
                <h3 className="text-lg font-semibold text-neutral-900">Recent Activity</h3>
                <p className="text-sm text-neutral-600 mt-1">Latest updates and modifications</p>
              </div>
              <Table
                removeWrapper
                aria-label="Activity logs table"
                classNames={{
                  th: "bg-neutral-50 text-neutral-700 font-medium",
                  td: "py-4",
                }}
                bottomContent={
                  <div className="flex items-center justify-center p-6">
                    <Pagination
                      showControls
                      color="primary"
                      page={currentPage}
                      total={totalPage}
                      onChange={(page) => setCurrentPage(page)}
                      classNames={{
                        item: "bg-transparent hover:bg-neutral-100",
                        cursor: "bg-primary-600 text-white",
                      }}
                    />
                  </div>
                }
              >
            <TableHeader>
              <TableColumn>Metric</TableColumn>
              <TableColumn>Updated at</TableColumn>
              <TableColumn>Updated by</TableColumn>
            </TableHeader>
            <TableBody>
              {responseData?.map((data, index) => {
                const colorIndex =
                  data?.attributes?.users_permissions_user?.data?.id %
                  numColors;
                return (
                  <TableRow
                    key={data?.id || index}
                    className="cursor-pointer hover:bg-neutral-200"
                    onClick={() =>
                      navigateHandler(data?.attributes?.Metric_Id, data?.id)
                    }
                  >
                    <TableCell>
                      <div className="flex gap-4 items-center">
                        <lord-icon
                          src="https://cdn.lordicon.com/nizfqlnk.json"
                          trigger="hover"
                          target="#Metrics"
                          state="morph-home-2"
                          
                          style={{ width: "25px", height: "25px" }}
                        ></lord-icon>
                        {data?.attributes?.Metric_Id}
                      </div>
                    </TableCell>
                    <TableCell>
                      {DateFormatorDD(data?.attributes?.updatedAt)}
                    </TableCell>
                    <TableCell>
                      <div className="flex gap-4 items-center">
                        <Avatar
                          className="h-6 w-6"
                          color={Colors[colorIndex]}
                          name={data?.attributes?.users_permissions_user?.data?.attributes?.email
                            .toUpperCase()
                            .slice(0, 1)}
                          src={
                            data?.attributes?.users_permissions_user?.data
                              ?.attributes?.ProfilePicture &&
                            `${process.env.REACT_APP_STRAPI_IP_ADDRESS}${data?.attributes?.users_permissions_user?.data?.attributes?.ProfilePicture.url}`
                          }
                        />
                        <div className="text-tiny text-default-500 font-bold">
                          {StringLimit(
                            data?.attributes?.users_permissions_user?.data
                              ?.attributes?.email,
                            30
                          )}
                        </div>
                      </div>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
            </div>
          </LoadingPage>
        </div>
      </BreadCrumbsPage>
    </div>
  );
};

export default Logs;
